import { render } from "./NewFinanceCard.vue?vue&type=template&id=bdc172f4&scoped=true"
import script from "./NewFinanceCard.vue?vue&type=script&lang=js"
export * from "./NewFinanceCard.vue?vue&type=script&lang=js"

import "./NewFinanceCard.vue?vue&type=style&index=0&id=bdc172f4&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc172f4"]])

export default __exports__